import "url-polyfill"; // Polyfill for URL and URLSearchParams (e.g. for IE11). See: https://github.com/lifaon74/url-polyfill#readme
import "./starts-with-polyfill.js"; // Polyfill startsWith(); (e.g. for IE11)

export default class UrlUtil {
	private static instances: WeakMap<Window, UrlUtil>;
	private static protocolAndSlashesRegExp = new RegExp('^(?:[a-z]+:)?//', 'i');

	private win: Window;
	private baseUrl: string;

	public static getInstance(win: Window = window) {
		if (UrlUtil.instances == undefined) {
			UrlUtil.instances = new WeakMap<Window, UrlUtil>();
		}
		if (UrlUtil.instances.has(win) === false) {
			const urlUtil = new UrlUtil(win);
			UrlUtil.instances.set(win, urlUtil);
			return urlUtil;
		}
		return UrlUtil.instances.get(win);
	}

	private constructor(win: Window) {
		this.win = win;
	}

	public toUrlObj(url: string): URL {
		if (UrlUtil.isAbsoluteUrl(url) === false) {
			url = this.applyBaseUrl(url);
		}
		return new URL(url);
	}

	public toUrlString(urlObj: URL, newParams?: URLSearchParams): string {
		if (newParams !== undefined && newParams !== null) {
			return urlObj.origin + urlObj.pathname +  "?" + newParams.toString() + urlObj.hash;
		}
		return urlObj.origin + urlObj.pathname + urlObj.hash;
	}

	public getBaseUrl(): string {
		if (this.baseUrl === undefined) {
			const bases = this.win.document.getElementsByTagName("base");
			if (bases.length > 0) {
				this.baseUrl = bases[bases.length - 1].href;
			} else {
				this.baseUrl = this.win.location.href.substring(0, window.location.href.lastIndexOf("/") + 1);
			}
		}
		return this.baseUrl;
	}

	/**
	 * Same as the static `applyBaseURL(...)` method but uses
	 * the base URL of this instance.
	 */
	public applyBaseUrl(url: string): string {
		return UrlUtil.applyBaseUrl(this.getBaseUrl(), url);
	}


	/**
	 * Determines if the URL is absolute or not.
	 * Note: This does will return true if the URL is missing the protocol and starts with "//".
	 */
	public static isAbsoluteUrl(url: string): boolean {
		return UrlUtil.protocolAndSlashesRegExp.test(url);
	}


	/**
	 * Applies the base URL to the URL, if the URL is not absolute.
	 * If the URL is missing the protocol, the protocole of the base URL will be applied.
	 */
	public static applyBaseUrl(baseUrl: string, url: string): string {
		const protocolAndSlashes = UrlUtil.protocolAndSlashesRegExp.exec(url);

		if (protocolAndSlashes === null || protocolAndSlashes.length === 0) {
			// URL is relative, apply base URL
			return baseUrl + url;
		}

		else if (protocolAndSlashes[0].startsWith("//") === true) {
			// URL is missing the protcol
			const baseUrlProtocolAndSlashes = UrlUtil.protocolAndSlashesRegExp.exec(baseUrl)[0];
			const baseProtocol = baseUrlProtocolAndSlashes.substring(0, baseUrlProtocolAndSlashes.length - 2);
			return baseProtocol + url;
		}

		// Original URL was already absolute
		return url;
	}
}